module.exports = __webpack_public_path__ + "static/media/close-black.43ce466c.svg";